// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'more';

export const Component = () => (
  <path d='M13.914 6.41c-.39.39-.877.586-1.414.586a1.953 1.953 0 0 1-1.414-.585 1.95 1.95 0 0 1-.586-1.413c0-.537.195-1.023.586-1.413.39-.39.877-.585 1.414-.585.537 0 1.024.195 1.414.585.39.39.586.876.586 1.413 0 .536-.195 1.023-.586 1.413Zm0 7.503c-.39.39-.877.585-1.414.585a1.953 1.953 0 0 1-1.414-.585A1.95 1.95 0 0 1 10.5 12.5c0-.536.195-1.022.586-1.413.39-.389.877-.584 1.414-.584a1.95 1.95 0 0 1 1.414.584c.39.39.586.877.586 1.413 0 .537-.195 1.023-.586 1.413Zm0 7.502c-.39.39-.877.585-1.414.585a1.953 1.953 0 0 1-1.414-.585 1.95 1.95 0 0 1-.586-1.413c0-.536.195-1.023.586-1.413.39-.39.877-.585 1.414-.585.537 0 1.024.195 1.414.585.39.39.586.877.586 1.413 0 .537-.195 1.023-.586 1.413Z' />
);

export const viewBox = '0 0 25 25';
